module.exports = __webpack_public_path__ + "fonts/Graphik-Regular.097b047.woff2";